module.exports = __webpack_public_path__ + "static/matthew_chignoli-85d0c28f090b4cda0839c456da224bc4.png";